import { Uploads } from '@/types/database/uploads';

const checkIsImage = async (url: string) => {
  const response = await fetch(url);
  const blob = await response.blob();
  return blob.type.includes('image');
};

export const getAnnouncementType = async (file: object | Uploads[]) => {
  let announcementType: 'text' | 'img' | 'file' = 'text';

  const isArray = Array.isArray(file);
  const hasFile = isArray && Object.keys(file[0]).includes('showPath');

  if (hasFile) {
    const filePath = file[0].showPath;
    const isImage = await checkIsImage(filePath);

    announcementType = isImage ? 'img' : 'file';
  }

  return announcementType;
};
